<template>
	<layout-page title="Dashboard">
		<div class="flex-grow flex flex-col bg-gray-100">
			<!-- header -->
			<div
				class="bg-green px-4 sm:px-6 py-4 md:rounded-tl-2xl lg:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center"
			>
				<h1 class="text-2xl md:text-4xl font-semibold text-white">
					{{ __("Dashboard") }}
				</h1>
			</div>

			<!-- filter bar -->

			<div
				class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 grid grid-cols-2 gap-x-6 gap-y-6"
			>
				<my-contracts-price-chart
					:data="data"
					:contracts="contracts"
					class="col-span-2"
				/>

				<my-contracts-price-chart-continuous
					:data="data"
					:contracts="contracts"
					class="col-span-2"
				/>
			</div>
		</div>
	</layout-page>
</template>

<script>
import { groupBy, sum, min, max, mean, range } from "lodash";
import * as echarts from "echarts";

export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
		contracts: {
			type: Array,
			required: true,
		},
	},
};
</script>
